import type { AxiosError, AxiosInstance } from "axios";

export function puckEditorLoginBuilder(apiClient: AxiosInstance) {
  return async function puckEditorLogin(
    email: string,
    password: string,
  ): Promise<any> {
    try {
      const response = await apiClient.post(`/auth/`, {
        username: email,
        password,
      });
      return response.data;
    } catch (error: unknown) {
      if ((error as AxiosError).response?.status === 404) {
        return null;
      } else {
        throw error;
      }
    }
  };
}
